module.exports = __webpack_public_path__ + "img/whatsapp.e919805.svg";